import classNames from 'classnames';
import React, { FunctionComponent, ReactNode } from 'react';
import styles from './ExtraMeasurements.scss';
import { FormattedDistance } from '../../Formatters/FormattedDistance';
import { FormattedDuration } from '../../Formatters/FormattedDuration';
import { useTranslation } from 'react-i18next';
import { ActivityTotal, ActivityTotalMeasurementTypes } from '../filters';

// import { timerIcon } from '@justgiving/icons';
// import { trendingIcon } from '@justgiving/icons';
// import Svg from '@justgiving/svg';

export interface ExtraMeasurementsProps {
  total: ActivityTotal;
  primaryMeasurementType: ActivityTotalMeasurementTypes;
}

const singleMeasurement = (label: ReactNode, content: ReactNode) => (
  <>
    {label}
    <span className={classNames(styles.value, 'jg-text--small-regular')}>
      {content}
    </span>
  </>
);

// const iconLabel = (svgMarkup: string) => (
//   <div className={styles.icon}>
//     <Svg markup={svgMarkup} />
//   </div>
// );

const textLabel = (label: string) => (
  <span className={classNames(styles.label, 'jg-text--small-light')}>
    {label}:
  </span>
);

export const ExtraMeasurements: FunctionComponent<ExtraMeasurementsProps> = ({
  total,
  primaryMeasurementType,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  return (
    <div className={styles.container}>
      {primaryMeasurementType !== 'duration' &&
        singleMeasurement(
          //iconLabel(timerIcon),
          textLabel(t('activity.totals.measurements.duration', 'Duration')),
          <FormattedDuration value={total.duration} />,
        )}
      {primaryMeasurementType !== 'distance' &&
        singleMeasurement(
          //iconLabel(trendingIcon),
          textLabel(t('activity.totals.measurements.distance', 'Distance')),
          <FormattedDistance value={total.distance} />,
        )}
      {primaryMeasurementType !== 'elevation' &&
        singleMeasurement(
          //iconLabel(trendingIcon),
          textLabel(t('activity.totals.measurements.elevation', 'Elevation')),
          <FormattedDistance value={total.elevation} />,
        )}
    </div>
  );
};
